import ReactDOM from 'react-dom/client';
import './index.module.scss';
import './styles/themeColors.scss';
import Root from './components/Root';
import { store } from "./config/store";
import Clarity from '@microsoft/clarity';

try {
  if (window.location.hostname === 'linzecar.cl') {
    Clarity.init('w1u7skcbiq');
  }
} catch (_) {}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if (window?.Cypress) {
    window.store = store;
}

root.render(<Root />);